Blain.OrderDetail = {

	initOrderDetail: function () {
		const $trackingLinks = $(".fx-tracking-link");
		const $trackingModal = $("#trackingModal");
		const $trackingProgress = $("#trackingProgress");
		const $trackingContainer = $("#trackingContainer");
		const $hoursLinks = $("#hoursLink");
		const $hoursModal = $("#hoursModal");
		const $hoursProgress = $("#hoursProgress");
		const $hoursContainer = $("#hoursContainer");
		const $hlPrintReturnDocs = $("#hlPrintReturnDocs");

		$hlPrintReturnDocs.off("click").on("click", print);

		function print() {
			window.frames["ifReturnInfo"].focus();
			window.frames["ifReturnInfo"].print();
		}

		$hoursLinks.off("click").on("click", function (e) {
			const that = this;
			$hoursContainer.html("");
			$hoursProgress.show();
			$hoursModal.blainModal("show");
			$.ajax({
				type: "POST",
				url: "/account/gethours",
				dataType: "json",
				data: JSON.stringify({
					id: $(that).data("blain-storenum")
				}),
				contentType: "application/json",
				error: function (xhr) {
					const obj = $.parseAjaxError(xhr);
					$.globalAjaxError(obj);
				},
				success: function (data) {
					$hoursProgress.hide();
					if (!data.status) {
						return;
					}
					$hoursContainer.html(data.html);
				}
			});
		});

		$trackingLinks.off("click").on("click", function (e) {
			const that = this;
			const courierID = $(that).data("courier");
			const trackingNumber = $(that).data("track");
			if (courierID === "ESTES") {
				const url = "https://www.estes-express.com/myestes/shipment-tracking/?type=PRO&query=" + trackingNumber;
				window.open(url);
				return;
			}
			$trackingContainer.html("");
			$trackingProgress.show();
			$trackingModal.blainModal("show");
			$.ajax({
				type: "POST",
				url: "/account/gettrackinginfo",
				dataType: "json",
				data: JSON.stringify({
					id: trackingNumber,
				}),
				contentType: "application/json",
				error: function (xhr) {
					const obj = $.parseAjaxError(xhr);
					$.globalAjaxError(obj);
				},
				success: function (data) {
					$trackingProgress.hide();
					if (!data.status) {
						$trackingModal.blainModal("hide");
						$.modalMsg({
							message: "Sorry, but we are not currently able to find tracking information for this item at this time. Please contact customer service for assistance at " + Blain.customerServicePhone + "."
						});
						return;
					}
					$trackingContainer.html(data.html);
				}
			});
		});
	},
};
